import { Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import { GameModel } from '../../../../../Models/Game/GameModel';
import { ExchangeModel } from '../Models/ExchangeModel';

@Singleton
export class GameLogic {
    constructor(
        @Inject private _model: ExchangeModel,
        @Inject private _gameModel: GameModel,
        @Inject private _modelEvents: ModelEvents,
    ) {
    }

    public reset(): void {

    }
}
